<template>
  <section class="ma-4 ma-md-8">
    <t-page-title title="Criação de Pré-Impressão" />
    <v-row justify="center" align="center">
      <v-col>
        <v-card class="pa-8">
          <form-pre-print @submit="($model: StorePayload) => submit($model)" />
        </v-card>
      </v-col>
    </v-row>
  </section>
</template>

<script lang="ts">

import { defineComponent } from 'vue'
import TPageTitle from '@/components/TPageTitle.vue'
import PrePrintService, { type StorePayload } from '@/services/PrePrintService'
import FormPrePrint from './form-pre-print.vue'

export default defineComponent({
  components: {
    TPageTitle,
    FormPrePrint,
  },
  data() {
    return {
      resource: 'pre-print',
    }
  },
  computed: {},
  methods: {
    async submit(payload: StorePayload) {
      this.$loader.increment()
      try {
        await (new PrePrintService()).store(payload)

        this.$snackbar.show(
          'Pré impressão criada com sucesso',
          'success',
        )

        this.$router.push({ name: 'list-pre-print' })
      } finally {
        this.$loader.decrement()
      }
    },
  },
})

</script>
